import type {SearchCriteriaRaw} from '../../../types';
import {createDateRule} from '../dateRule';
import type {DateRule, TSearchTypeDate} from '../types';

export type RawDateSearchCriteria = SearchCriteriaRaw<TSearchTypeDate>;

export const rawDateCriteriaToRuleObject = (
	criteria: RawDateSearchCriteria,
): DateRule<any> => {
	return createDateRule({
		type: criteria.subtype1,
		subType: criteria.subtype2,
		date: criteria.value1,
		attributeName: criteria.value3,
		fromDate: criteria.value1,
		toDate: criteria.value2,
	} as any) as DateRule<any>;
};

export default rawDateCriteriaToRuleObject;
